import React from 'react';
import Text from '../Text/Text';
import './CguSite.css';
import SectionTitle from '../SectionTitle/SectionTitle';

const CguSite = () => {
  return (
    <div className="CguSite">
      <SectionTitle classname="CguSite__main">
        Conditions générales d'utilisation et mentions légales
      </SectionTitle>
      <SectionTitle classname="CguSite__title">
        1. PRÉSENTATION DU SITE
      </SectionTitle>
      <Text classname="CguSite__text">
        En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la
        confiance dans l'économie numérique, il est précisé aux utilisateurs du
        site https://www.pharmaciecos.fr l'identité des différents intervenants
        dans le cadre de sa réalisation et de son suivi :
      </Text>
      <Text classname="CguSite__text">- Raison sociale :</Text>
      <Text classname="CguSite__text">COOPÉRATIVE OBJECTIF SANTÉ</Text>
      <Text classname="CguSite__text">
        COOPÉRATIVE OBJECTIF SANTÉ Le présent site est la propriété de la
        société coopérative à forme anonyme à capital variable COOPÉRATIVE
        OBJECTIF SANTÉ, au capital social de 19 000 euros, n° SIRET
        81060129400038, n° SIREN 810 601 294, n° TVA intracommunautaire
        FR23810601294.
      </Text>
      <Text classname="CguSite__text">- Adresse :</Text>
      <Text classname="CguSite__text">
        26, rue du Faubourg Saint-Antoine, 75012 Paris
      </Text>
      <Text classname="CguSite__text">- Responsable publication :</Text>
      <Text classname="CguSite__text">
        Frank Saffar, gérant de COOPÉRATIVE OBJECTIF SANTÉ -
        frank@cospharmacie.fr - Le responsable publication est une personne
        physique ou une personne morale.
      </Text>
      <Text classname="CguSite__text">- Conception et réalisation :</Text>
      <Text classname="CguSite__text">
        Le site https://www.pharmaciecos.fr a été conçu par Valwin, société par
        action simplifiées au capital de 40 500 €, n° SIREN 791 450 653, n° TVA
        intracommunautaire FR36 791450653 dont le siège social est situé au 86
        quai de la Fosse, 44000 Nantes. Site internet : https://www.valwin.fr
      </Text>
      <Text classname="CguSite__text">- Hébergeur :</Text>
      <Text classname="CguSite__text">
        Clever Cloud SAS - 3 rue de l'Allier, 44000 Nantes
      </Text>
      <SectionTitle classname="CguSite__title">
        2. CONDITIONS GÉNÉRALES D’UTILISATION DU SITE ET DES SERVICES PROPOSÉS.
      </SectionTitle>
      <Text classname="CguSite__text">
        L’utilisation du site https://www.pharmaciecos.fr implique l’acceptation
        pleine et entière des conditions générales d’utilisation ci-après
        décrites. Ces conditions d’utilisation sont susceptibles d’être
        modifiées ou complétées à tout moment, les utilisateurs du site
        https://www.pharmaciecos.fr sont donc invités à les consulter de manière
        régulière. Ce site est normalement accessible à tout moment aux
        utilisateurs. Une interruption pour raison de maintenance technique peut
        être toutefois décidée par COOPÉRATIVE OBJECTIF SANTÉ, qui s’efforcera
        alors de communiquer préalablement aux utilisateurs les dates et heures
        de l’intervention. Le site https://www.pharmaciecos.fr est mis à jour
        régulièrement par Monsieur Frank Saffar. De la même façon, les mentions
        légales peuvent être modifiées à tout moment : elles s’imposent
        néanmoins à l’utilisateur qui est invité à s’y référer le plus souvent
        possible afin d’en prendre connaissance.
      </Text>
      <SectionTitle classname="CguSite__title">
        3. DESCRIPTION DES SERVICES FOURNIS.
      </SectionTitle>
      <Text classname="CguSite__text">
        Le site https://www.pharmaciecos.fr a pour objet de fournir une
        information concernant l’ensemble des activités de la société.
        COOPÉRATIVE OBJECTIF SANTÉ s’efforce de fournir sur le site
        https://www.pharmaciecos.fr des informations aussi précises que
        possible. Toutefois, il ne pourra être tenu responsable des omissions,
        des inexactitudes et des carences dans la mise à jour, qu’elles soient
        de son fait ou du fait des tiers partenaires qui lui fournissent ces
        informations. Toutes les informations indiquées sur le site
        https://www.pharmaciecos.fr sont données à titre indicatif, et sont
        susceptibles d’évoluer. Par ailleurs, les renseignements figurant sur le
        site https://www.pharmaciecos.fr ne sont pas exhaustifs. Ils sont donnés
        sous réserve de modifications ayant été apportées depuis leur mise en
        ligne.
      </Text>
      <SectionTitle classname="CguSite__title">
        4. LIMITATIONS CONTRACTUELLES SUR LES DONNÉES TECHNIQUES.
      </SectionTitle>
      <Text classname="CguSite__text">
        Le site internet ne pourra être tenu responsable de dommages matériels
        liés à l’utilisation du site. De plus, l’utilisateur du site s’engage à
        accéder au site en utilisant un matériel récent, ne contenant pas de
        virus et avec un navigateur de dernière génération mis à jour.
      </Text>
      <SectionTitle classname="CguSite__title">
        5. PROPRIÉTÉ INTELLECTUELLE ET CONTREFAÇONS.
      </SectionTitle>
      <Text classname="CguSite__text">
        COOPÉRATIVE OBJECTIF SANTÉ est propriétaire des droits de propriété
        intellectuelle ou détient les droits d’usage sur tous les éléments
        accessibles sur le site, notamment les textes, images, graphismes,
        logos, icônes, sons. Les éléments issus des Blogs (Blog Santé, Blog
        Professionnels de santé, Blog Tech) dont le contenu textuel et visuel
        ayant pour source une curation (i.e “via Scoopit”) et les éléments
        logiciels en sont exclus. Toute reproduction, représentation,
        modification, publication, adaptation de tout ou partie des éléments du
        site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf
        autorisation écrite préalable de : COOPÉRATIVE OBJECTIF SANTÉ, toute
        exploitation non autorisée du site ou de l’un quelconque des éléments
        qu’il contient sera considérée comme constitutive d’une contrefaçon et
        poursuivie conformément aux dispositions des articles L.335-2 et
        suivants du Code de Propriété Intellectuelle.
      </Text>
      <SectionTitle classname="CguSite__title">
        6. LIMITATIONS DE RESPONSABILITÉ.
      </SectionTitle>
      <Text classname="CguSite__text">
        COOPÉRATIVE OBJECTIF SANTÉ ne pourra être tenue responsable des dommages
        directs et indirects causés au matériel de l’utilisateur, lors de
        l’accès au site https://www.pharmaciecos.fr, et résultant soit de
        l’utilisation d’un matériel ne répondant pas aux spécifications
        indiquées au point 4, soit de l’apparition d’un bug ou d’une
        incompatibilité. COOPÉRATIVE OBJECTIF SANTÉ ne pourra également être
        tenue responsable des dommages indirects (tels par exemple qu’une perte
        de marché ou perte d’une chance) consécutifs à l’utilisation du site
        https://www.pharmaciecos.fr.
      </Text>
      <SectionTitle classname="CguSite__title">
        7. GESTION DES DONNÉES PERSONNELLES.
      </SectionTitle>
      <Text classname="CguSite__text">
        En France, les données personnelles sont notamment protégées par la loi
        n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l'article
        L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995. A
        l'occasion de l'utilisation du site https://www.pharmaciecos.fr, peuvent
        êtres recueillies : l'URL des liens par l'intermédiaire desquels
        l'utilisateur a accédé au site https://www.pharmaciecos.fr, le
        fournisseur d'accès de l'utilisateur, l'adresse de protocole Internet
        (IP) de l'utilisateur. Le site n'est pas déclaré à la CNIL car il ne
        recueille pas d'informations personnelles.
      </Text>
      <SectionTitle classname="CguSite__title">
        8. LIENS HYPERTEXTES ET COOKIES.
      </SectionTitle>
      <Text classname="CguSite__text">
        Le site https://www.pharmaciecos.fr contient un certain nombre de liens
        hypertextes vers d’autres sites, mis en place avec l’autorisation de
        COOPÉRATIVE OBJECTIF SANTÉ. Cependant, COOPÉRATIVE OBJECTIF SANTÉ n’a
        pas la possibilité de vérifier le contenu des sites ainsi visités, et
        n’assumera en conséquence aucune responsabilité de ce fait. La
        navigation sur le site https://www.pharmaciecos.fr est susceptible de
        provoquer l’installation de cookie(s) sur l’ordinateur de l’utilisateur.
        Un cookie est un fichier de petite taille, qui ne permet pas
        l’identification de l’utilisateur, mais qui enregistre des informations
        relatives à la navigation d’un ordinateur sur un site. Les données ainsi
        obtenues visent à faciliter la navigation ultérieure sur le site, et ont
        également vocation à permettre diverses mesures de fréquentation. Le
        refus d’installation d’un cookie peut entraîner l’impossibilité
        d’accéder à certains services. L’utilisateur peut toutefois configurer
        son ordinateur de la manière suivante, pour refuser l’installation des
        cookies :
      </Text>
      <Text classname="CguSite__text">- Sous Internet Explorer :</Text>
      <Text classname="CguSite__text">
        Onglet outil (pictogramme en forme de rouage en haut à droite) / options
        internet. Cliquez sur Confidentialité et choisissez Bloquer tous les
        cookies. Validez sur Ok.
      </Text>
      <Text classname="CguSite__text">- Sous Firefox :</Text>
      <Text classname="CguSite__text">
        En haut de la fenêtre du navigateur, cliquez sur le bouton Firefox, puis
        allez dans l'onglet Options. Cliquer sur l'onglet Vie privée. Paramétrez
        les Règles de conservation sur : utiliser les paramètres personnalisés
        pour l'historique. Enfin décochez-la pour désactiver les cookies.
      </Text>
      <Text classname="CguSite__text">- Sous Safari :</Text>
      <Text classname="CguSite__text">
        Cliquez en haut à droite du navigateur sur le pictogramme de menu
        (symbolisé par un rouage). Sélectionnez Paramètres. Cliquez sur Afficher
        les paramètres avancés. Dans la section “Confidentialité”, cliquez sur
        Paramètres de contenu. Dans la section “Cookies”, vous pouvez bloquer
        les cookies.
      </Text>
      <Text classname="CguSite__text">- Sous Chrome :</Text>
      <Text classname="CguSite__text">
        Cliquez en haut à droite du navigateur sur le pictogramme de menu
        (symbolisé par trois lignes horizontales). Sélectionnez Paramètres.
        Cliquez sur Afficher les paramètres avancés. Dans la section
        “Confidentialité”, cliquez sur préférences. Dans l'onglet
        “Confidentialité”, vous pouvez bloquer les cookies.
      </Text>
      <Text classname="CguSite__text">
        Ces configurations techniques minimales sont susceptibles d’évoluer sans
        préavis. Le PATIENT est seul responsable de la compatibilité entre son
        équipement et le SITE.
      </Text>
      <SectionTitle classname="CguSite__title">
        9. DROIT APPLICABLE ET ATTRIBUTION DE JURIDICTION.
      </SectionTitle>
      <Text classname="CguSite__text">
        Tout litige en relation avec l’utilisation du site
        https://www.pharmaciecos.fr est soumis au droit français. Il est fait
        attribution exclusive de juridiction aux tribunaux compétents de Paris.
      </Text>
      <SectionTitle classname="CguSite__title">
        10. LES PRINCIPALES LOIS CONCERNÉES.
      </SectionTitle>
      <Text classname="CguSite__text">
        Loi n° 78-87 du 6 janvier 1978, notamment modifiée par la loi n°
        2004-801 du 6 août 2004 relative à l'informatique, aux fichiers et aux
        libertés. Loi n° 2004-575 du 21 juin 2004 pour la confiance dans
        l'économie numérique.
      </Text>
      <SectionTitle classname="CguSite__title">11. LEXIQUE.</SectionTitle>
      <Text classname="CguSite__text">- Utilisateur : </Text>
      <Text classname="CguSite__text">
        Internaute se connectant, utilisant le site susnommé.
      </Text>
      <Text classname="CguSite__text">- Informations personnelles : </Text>
      <Text classname="CguSite__text">
        « les informations qui permettent, sous quelque forme que ce soit,
        directement ou non, l'identification des personnes physiques auxquelles
        elles s'appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).
      </Text>
    </div>
  );
};

export default CguSite;
